/**
 * Avoid race condition when are importing the store from the redux
 */
export let externalStore: any = undefined;

export const setExternalStore = (store: any) => {
  externalStore = store;
};
